import React from "react";

const TIERS = [
  { label: "🟢 Novice", req: "Just joined" },
  { label: "🔵 Trader", req: "5+ closed trades" },
  { label: "🟣 Analyst", req: "20+ trades, 55%+ win rate" },
  { label: "🟠 Pro Trader", req: "50+ trades, 65%+ win rate" },
  { label: "🏆 Monthly Champion", req: "Won a monthly challenge" },
  { label: "👑 Elite", req: "3+ monthly wins" },
];

export default function BadgeInfoPanel() {
  return (
    <div className="bg-[var(--bg-panel)] border border-[var(--border-soft)] rounded-xl p-5">
      <h3 className="font-mono text-xs uppercase tracking-widest text-[var(--text-tertiary)] mb-3">Trader Ranks</h3>
      <div className="space-y-2">
        {TIERS.map((t) => (
          <div key={t.label} className="flex justify-between text-sm">
            <span className="text-[var(--text-primary)]">{t.label}</span>
            <span className="text-[var(--text-tertiary)] text-xs">{t.req}</span>
          </div>
        ))}
      </div>
    </div>
  );
}